const BriefcaseClock = () => {
  return (
    <svg
      width="32"
      height="33"
      viewBox="0 0 32 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.5"
        y="0.857422"
        width="31"
        height="31"
        rx="3.5"
        stroke="#01A76A"
      />
      <mask
        id="mask0_6798_65859"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="8"
        y="8"
        width="16"
        height="17"
      >
        <rect x="8" y="8.35742" width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_6798_65859)">
        <path
          d="M10.6667 22.3575C10.3 22.3575 9.98615 22.2269 9.72504 21.9658C9.46393 21.7047 9.33337 21.3908 9.33337 21.0241V13.6908C9.33337 13.3241 9.46393 13.0102 9.72504 12.7491C9.98615 12.488 10.3 12.3575 10.6667 12.3575H13.3334V11.0241C13.3334 10.6575 13.4639 10.3436 13.725 10.0825C13.9862 9.82135 14.3 9.6908 14.6667 9.6908H17.3334C17.7 9.6908 18.0139 9.82135 18.275 10.0825C18.5362 10.3436 18.6667 10.6575 18.6667 11.0241V12.3575H21.3334C21.7 12.3575 22.0139 12.488 22.275 12.7491C22.5362 13.0102 22.6667 13.3241 22.6667 13.6908V16.5408C22.4667 16.3964 22.2556 16.2714 22.0334 16.1658C21.8112 16.0602 21.5778 15.9686 21.3334 15.8908V13.6908H10.6667V21.0241H15.3834C15.4167 21.2575 15.4667 21.4852 15.5334 21.7075C15.6 21.9297 15.6834 22.1464 15.7834 22.3575H10.6667ZM14.6667 12.3575H17.3334V11.0241H14.6667V12.3575ZM20 23.6908C19.0778 23.6908 18.2917 23.3658 17.6417 22.7158C16.9917 22.0658 16.6667 21.2797 16.6667 20.3575C16.6667 19.4352 16.9917 18.6491 17.6417 17.9991C18.2917 17.3491 19.0778 17.0241 20 17.0241C20.9223 17.0241 21.7084 17.3491 22.3584 17.9991C23.0084 18.6491 23.3334 19.4352 23.3334 20.3575C23.3334 21.2797 23.0084 22.0658 22.3584 22.7158C21.7084 23.3658 20.9223 23.6908 20 23.6908ZM20.3334 20.2241V18.3575H19.6667V20.4908L21.1 21.9241L21.5667 21.4575L20.3334 20.2241Z"
          fill="#01A76A"
        />
      </g>
    </svg>
  )
}

export default BriefcaseClock
